import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./../common/Sidebar";
import Header from "./../common/Header";
import Footer from "./../common/Footer";
import "./../../assets/style/Layout.css";
import { useUser } from "../Commonfunction/UserContext";
import { getData } from "../Commonfunction/CommonFunction";

const Layout = ({ onLogout }) => {
  const { userAccess, setUserAccess } = useUser("");

  const fetchData = async () => {
    try {
      const result = await getData("/api/user-access");
      if (result.success) {
        setUserAccess(result);
      }
    } catch (error) {
      console.log("Error:123213", error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div className="argon-container">
      <Sidebar userAccessData={userAccess} />
      <main className="argon-main">
        <Header onLogout={onLogout} />
        <div className="argon-content">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default Layout;
